<p-table stripedRows #fileFormat
    [value]="items"
    dataKey="id"
    editMode="row"
    scrollHeight="flex"
    [style]="{ 'min-width': '70em', width: '100%' }"
    [scrollable]="true"
    [virtualRowHeight]="30"
    (onRowReorder)="onRowReorderHandler($event)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <!-- Reorder grabber-->
            <th *ngIf="false" class="select-cell"></th>
            <!-- Name-->
            <th>
                Export Field
                <p-sortIcon
                    pSortableColumn="PropertyName"
                    field="PropertyName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <th>Group By</th>
            <!-- InUse-->
            <th>Show</th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pReorderableRow]="ri"
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
        >
            <!-- Reorder grabber-->
            <td *ngIf="false" class="select-cell">
                <span
                    class="pi pi-bars"
                    pReorderableRowHandle
                    title="click and drag to re-order"
                ></span>
            </td>
            <!-- Name-->
            <td class="disabled">
                {{ item?.PropertyName }}
            </td>
            <!-- Group By-->
            <td>
                <p-checkbox
                    *ngIf="item.PropertyType === 'Group'"
                    [(ngModel)]="item.InUse"
                    [binary]="true"
                    (onChange)="onRowEditSave(item)"
                    [disabled]="shouldDisable(item)"
                ></p-checkbox>
            </td>
            <!-- Show-->
            <td>
                <p-checkbox
                    *ngIf="item.PropertyType !== 'Group'"
                    [(ngModel)]="item.InUse"
                    [binary]="true"
                    (onChange)="onRowEditSave(item)"
                    [disabled]="shouldDisable(item)"
                ></p-checkbox>
            </td>
        </tr>
    </ng-template>
</p-table>
